import {useCallback, useSyncExternalStore} from "react";

// Phones; keep in line with the "max-width: 767px" media queries of the stylesheets
export const MOBILE_QUERY = "(max-width: 767px)";

/**
 * Whether the CSS media query matches, updated when it changes (e.g. when the window is resized).
 */
const useMediaQuery = query => {
  const subscribe = useCallback(onChange => {
    const mediaQuery = window.matchMedia(query);

    mediaQuery.addEventListener("change", onChange);

    return () => mediaQuery.removeEventListener("change", onChange);
  }, [query]);

  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
};

export default useMediaQuery;
